import React from "react";
import {ResponsiveLine} from "@nivo/line";

export default function LineChart(props) {
  return (
    <div style={{height: "300px", width: "100%"}}>
      <ResponsiveLine
        data={props.data}
        margin={{top: 50, right: 200, bottom: 50, left: 60}}
        xScale={{type: "point"}}
        yScale={{
          type: "linear",
          min: "auto",
          max: "auto",
          stacked: false,
          reverse: false
        }}
        axisTop={null}
        axisRight={null}
        colors={["#FF0000", "#00FF00"]}
        axisBottom={null}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: props.labels.y,
          legendOffset: -40,
          legendPosition: "middle",
          truncateTickAt: 0
        }}
        pointSize={10}
        enableGridX={false}
        enableGridY={true}
        curve="monotoneX"
        pointColor={{theme: "background"}}
        pointBorderWidth={2}
        pointBorderColor={{from: "serieColor"}}
        pointLabelYOffset={-12}
        enableTouchCrosshair={true}
        useMesh={true}
        legends={[
          {
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: "left-to-right",
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: "circle",
            symbolBorderColor: "rgba(0, 0, 0, .5)",
            effects: [
              {
                on: "hover",
                style: {
                  itemBackground: "rgba(0, 0, 0, .03)",
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
      />
    </div>
  );
}
